// extracted by mini-css-extract-plugin
module.exports = {"Services":"Services_Services__T_69j","Card":"Services_Card__2UZ-P","Img":"Services_Img__3i2GZ","Title":"Services_Title__3eQ7s"};